<template>
  <BaseText bold>{{ $t('onboarding.new_onboarding.customer.title') }}</BaseText>
  <div :class="$style.base">
    <div :class="$style.input">
      <BaseCard gray>
        <BaseInput
          v-model="customer.firstName"
          :focus="focusInputField"
          :label="$t('global.first_name')"
          :class="$style.input"
          required
          v-test="'employeeFirstName'"
        />
        <BaseInput
          v-model="customer.lastName"
          :label="$t('global.last_name')"
          :class="$style.input"
          mt
          required
          v-test="'employeeLastName'"
        />
      </BaseCard>
    </div>
    <img
      v-if="$screen !== 's'"
      src="/img/onboarding/customer.svg"
    >
  </div>
</template>

<script
  lang="ts"
  setup
>
defineProps<{
  customer: { firstName: string; lastName: string };
  focusInputField: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: start;
  justify-content: space-between;
}

.input {
  width: 330px;
  padding-top: $spacing;
  padding-right: $spacing;
}
</style>
